import template from './loading-indicator.html';

const LoadingIndicator = {
  dots: 'dots',
  spinner: 'spinner',
  spinnerDouble: 'spinner-double'
};

export const loadingIndicatorComponent = {
  name: 'loadingIndicator',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: function() {
    'ngInject';
    // Indicator defaults to spinner
    if (!this.indicator) {
      this.indicator = LoadingIndicator.spinner;
    }
  },
  bindings: {
    isLoading: '<',
    indicator: '@'
  }
};
